<template>
  <div class="app">
    <app-auth />
    <menu-fetcher />
    <seat-scheduler />
    <shop-detail />
    <custom-scheme />
    <seat-status-watcher />
    <error-unhandled v-if="hasUnhandledError" :language="language" />
    <template v-else>
      <auth-loader v-if="isInitializing" />
      <welcome-content v-else-if="isAuthUnabled && !isUs && !isCn" />
      <welcome-content-us v-else-if="isAuthUnabled && isUs" />
      <welcome-content-cn v-else-if="isAuthUnabled && isCn" />
      <unauthenticated-content v-else-if="isAuthFailed" />
      <authenticated-content v-else-if="isAuthenticated" />
      <thank-you v-else-if="isAuthQuitted && isJp" />
      <thank-you-taiwan v-else-if="isAuthQuitted && isTw" />
      <thank-you-china v-else-if="isAuthQuitted && isCn" />
      <thank-you-us v-else-if="isAuthQuitted && isUs" />
    </template>
    <modal-wrap />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AuthLoader from '@/components/loader/AuthLoader'
import AppAuth from '@/components/service/AppAuth'
import AppAuthWeb from '@/components/service/AppAuthWeb'
import MenuFetcher from '@/components/service/MenuFetcher'
import SeatScheduler from '@/components/service/SeatScheduler'
import ShopDetail from '@/components/service/ShopDetail'
import CustomScheme from '@/components/service/CustomScheme'
import SeatStatusWatcher from '@/components/service/SeatStatusWatcher'
import ModalWrap from '@/components/modal/ModalWrap'
import ThankYou from '@/components/contents/ThankYou'
import ThankYouTaiwan from '@/components/contents/ThankYouTaiwan'
import ThankYouChina from '@/components/contents/ThankYouChina'
import ThankYouUs from '@/components/contents/ThankYouUs'
import Unhandled from '@/components/error/Unhandled'
import Unauthenticated from '@/components/contents/Unauthenticated'
import Authenticated from '@/components/contents/Authenticated'
import Welcome from '@/components/contents/Welcome'
import WelcomeUs from '@/components/contents/WelcomeUs'
import WelcomeCn from '@/components/contents/WelcomeCn'

export default {
  components: {
    AppAuth: process.env.VUE_APP_TYPE === 'app' ? AppAuth : AppAuthWeb,
    AuthLoader,
    MenuFetcher,
    SeatScheduler,
    ShopDetail,
    CustomScheme,
    SeatStatusWatcher,
    ModalWrap,
    WelcomeContent: Welcome,
    WelcomeContentUs: WelcomeUs,
    WelcomeContentCn: WelcomeCn,
    UnauthenticatedContent: Unauthenticated,
    AuthenticatedContent: Authenticated,
    ErrorUnhandled: Unhandled,
    ThankYou,
    ThankYouTaiwan,
    ThankYouChina,
    ThankYouUs,
  },
  computed: {
    ...mapGetters({
      isUnauthenticated: 'auth/getIsUnauthenticated',
      isAuthenticated: 'auth/getIsAuthenticated',
      isAuthUnabled: 'auth/getIsAuthUnabled',
      isAuthFailed: 'auth/getIsAuthFailed',
      isAuthQuitted: 'auth/getIsAuthQuitted',
      hasUnhandledError: 'error/getHasUnhandledError',
      seatNo: 'seat/getSeatNo',
      hasMenu: 'menu/getHasMenu',
      language: 'setting/getLanguage',
    }),
    isInitializing() {
      if (this.isUnauthenticated) return true
      if (this.isAuthenticated && !this.hasSeatNo) return true
      if (this.isAuthenticated && !this.hasMenu) return true
      else return false
    },
    hasSeatNo() {
      return this.seatNo !== null
    },
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
    isJp() {
      return this.defaultLanguage === 'ja'
    },
    isTw() {
      return this.defaultLanguage === 'zh-tw'
    },
    isCn() {
      return this.defaultLanguage === 'zh-cn'
    },
    isUs() {
      return this.defaultLanguage === 'us'
    },
  },
  mounted() {
    this.hideDomLoader()
  },
  methods: {
    hideDomLoader() {
      const loader = document.getElementById('loading')
      if (loader) loader.style.display = 'none'
    },
  },
}
</script>
<style lang="scss" scoped>
.app {
  height: 100%;
}
@font-face {
  font-family: 'Zen Antique Soft';
  src: url(~@/assets/fonts/ZenAntiqueSoft-Regular-Edited.woff) format('woff');
}
</style>
